<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="[ stack ]" data-cy="register-form">
  <dcr-text-field
    class="[ w-full ]"
    label="E-mailadres"
    type="email"
    formControlName="email"
    data-cy="input-register-form-email"
  ></dcr-text-field>

  <dcr-text-field
    class="[ w-full ]"
    label="Wachtwoord"
    type="password"
    formControlName="password"
    data-cy="input-register-form-password"
    validation-message-no-context="Het wachtwoord mag geen woorden uit de context bevatten zoals de naam van het platform."
    validation-message-no-user-info="Het wachtwoord mag geen gegevens bevatten zoals je naam, voornaam of gebruikersnaam."
    validation-message-unknown-error="Er is een onbekende fout opgetreden."
  ></dcr-text-field>

  <dcr-text-field
    class="[ w-full ]"
    label="Herhaal nieuw wachtwoord"
    type="password"
    formControlName="passwordCheck"
    data-cy="input-register-form-repeat-password"
    validation-message-noPasswordMatch="De wachtwoorden komt niet overeen"
  ></dcr-text-field>

  <div
    class="[ corner-m p-i-m p-b-s error-container border border-error body-large ]"
    *ngIf="error"
    data-cy="register-form-error"
  >
    Het registreren is mislukt. Probeer later opnieuw of contacteer de helpdesk.
    <a [href]="portalEnvironment.ui.contact.helpdesk.link">{{ portalEnvironment.ui.contact.helpdesk.label }}</a>
  </div>
  <div class="[ cluster ]">
    <div class="[ justify-between ]">
      <dcr-filled-button
        type="submit"
        label="Registreren"
        [disabled]="!registerForm.valid"
        data-cy="btn-register-form-submit"
      >
      </dcr-filled-button>
      <dcr-inline-button
        label="Terug naar aanmelden"
        routerLink="/login"
        data-cy="btn-register-form-login"
      >
      </dcr-inline-button>
    </div>
  </div>
</form>
